import { Theme } from "@mui/material/styles";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";

// The number of header cells below. The loading skeleton and the empty-state row span this many
// columns, so it has to change whenever a column is added or removed.
export const COLUMNS = 12;

const dividedCellSx = {
  borderRight: (theme: Theme) => `1px solid ${theme.palette.draft.main}`,
};

const headSx = {
  bgcolor: (theme: Theme) => theme.palette.background.default,
};

export default function TransactionsTableHead() {
  return (
    <TableHead sx={headSx}>
      <TableRow>
        <TableCell sx={dividedCellSx}>เลขที่</TableCell>
        <TableCell sx={dividedCellSx}>วันที่</TableCell>
        <TableCell sx={dividedCellSx}>รหัสลูกค้า</TableCell>
        <TableCell
          sx={{
            ...dividedCellSx,
            alignItems: "flex-start",
            verticalAlign: "middle",
          }}
        >
          ชื่อลูกค้า
        </TableCell>
        <TableCell sx={dividedCellSx}>Tax ID</TableCell>
        <TableCell sx={dividedCellSx}>ประเภท</TableCell>
        <TableCell sx={dividedCellSx}>สถานะ</TableCell>
        <TableCell sx={dividedCellSx}>ช่องทางการจ่ายเงิน</TableCell>
        <TableCell align="right" sx={dividedCellSx}>
          จำนวนเงิน (บาท)
        </TableCell>
        <TableCell align="center" sx={dividedCellSx}>
          พิมพ์แล้ว
        </TableCell>
        <TableCell align="center" sx={dividedCellSx}>
          ดาวน์โหลด
        </TableCell>
        <TableCell align="center">จัดการ</TableCell>
      </TableRow>
    </TableHead>
  );
}
